import { createAbha } from '../../api/abha/create-abha';
import { getDoc, getMe, getMySingleDoctorId } from '../../store/idbHandler';
import { Patient } from '../../store/types/patient';
import { getAbhaSuggestions, splitFullName } from '../../store/utils';
import { track } from '../../tracking';

export const linkAbha = async (
    docid: string,
    cId: string,
    patient: Patient,
    txnId: string,
    skip_state?: string,
    onLoading?: () => void,
    onError?: (message?: string) => void,
    onSuccess?: () => void,
) => {
    if (skip_state && skip_state === 'abha_end') {
        onSuccess && onSuccess();
        return;
    }

    try {
        const [year, month, date] = patient.personal.age!.dob!.split('-');
        const { firstName, lastName, middleName } = splitFullName(patient.personal.name.f);
        const gender = patient.personal.gender;

        const suggestedAbhaId = getAbhaSuggestions(
            patient.personal.name.f || '',
            patient.personal.phone?.n || '',
        );

        const pin =
            getDoc()?.profile.professional.clinics && getDoc()?.profile.professional.clinics![0]
                ? getDoc()?.profile.professional.clinics![0]?.address?.pin
                : undefined;

        onLoading && onLoading();

        const res = await createAbha(docid, cId, getMe()?.business?.id || '', {
            txn_id: txnId,
            day_of_birth: date,
            year_of_birth: year,
            month_of_birth: month,
            first_name: firstName,
            last_name: lastName,
            middle_name: middleName,
            gender: gender === 'Male' ? 'M' : gender === 'Female' ? 'F' : 'O',
            health_id: suggestedAbhaId,
            name: patient.personal.name.f,
            pincode: pin ?? '560048',
        });

        if (res.error) {
            throw new Error(res.error);
        }

        onSuccess && onSuccess();
    } catch (error: any) {
        console.error(error?.message);
        track('LINK_ABHA_FAILED', { message: error?.message });
        onError && onError(error?.message);
    }
};
